module.exports = __webpack_public_path__ + "img/menu_free_court.9ae990dc.jpg";